(function(){
     'use strict';

     angular
        .module('app')
        .factory('PaginasService', PaginasService);

    PaginasService.$inject = ['$http'];

    function PaginasService($http){

        var service= {
            getBloqueEdit: getBloqueEdit,
            saveDatos: saveDatos,
            getPreview:getPreview,
            getFormSimple:getFormSimple,
            getAllBlocks:getAllBlocks
        };

        return service;

        function getBloqueEdit(vm,bloque,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                lang_id : vm.lang_id,
                page_id : vm.page_id,
                bloque: bloque
            });
            $http.post('/backend/altcrm/paginas/editarbloque', data, config)
            .success(getPaginasSuccess)
            .error(getPaginasFailed);
            function getPaginasSuccess(data){ 
                callback(data);
            }
            function getPaginasFailed(data){
                
                return false;
            }
        }
        

        function saveDatos(vm,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var json = $('.infoPage').serializeObject();
            console.log(vm.duplicar);
            var page = "";
            if(vm.duplicar==1){
                page = "";
            }else{
                page = vm.page_id;
            }
            var data = $.param({
                datos: angular.toJson(vm.datos),
                json : json,
                lang_id : vm.lang_id,
                duplicar : vm.duplicar,
                page_id : page
            });
            
            $http.post('/backend/altcrm/paginas/guardardatos', data, config)
            .success(getPaginasSuccess)
            .error(getPaginasFailed);
            function getPaginasSuccess(data){ 
                callback(data);
            }
            function getPaginasFailed(data){
                
                return false;
            }
        }

        function getPreview(datos,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var json = $('.infoPage').serializeObject();
            var data = $.param({
                datos: datos,
                json : json,
                lang_id : CONST_lang_id,
                page_id : CONST_id,
                duplicar: CONST_duplicar
            });
            $http.post('/async/preview', data, config)
            .success(getPaginasSuccess)
            .error(getPaginasFailed);
            function getPaginasSuccess(data){ 
                callback(data);
            }
            function getPaginasFailed(data){
                
                return false;
            }
        }

        function getFormSimple(id,lang_id,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               lang_id:lang_id,
               id:id
            });
            $http.post('/backend/altcrm/paginas/formpagesimple', data, config)
            .success(getPaginasSuccess)
            .error(getPaginasFailed);
            function getPaginasSuccess(data){ 
                callback(data);
            }
            function getPaginasFailed(data){
                
                return false;
            }
        }

        function getAllBlocks(vm,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               lang_id:vm.lang_id,
               id:vm.page_id,
               lang_id_copy:vm.lang_id_copy
            });
            $http.post('/backend/altcrm/paginas/getallblocks', data, config)
            .success(getPaginasSuccess)
            .error(getPaginasFailed);
            function getPaginasSuccess(data){ 
                callback(data);
            }
            function getPaginasFailed(data){
                
                return false;
            }
        }
    }
})();